import React, { useContext, useEffect, useState } from "react";
import { Tab, TabList } from "@fluentui/react-components";
import CustomPopover from "../../components/popover/Popover";
import CustomButton from "../../components/controls/button/Button";
import IconInput from "../../components/controls/input/iconInput/IconInput";
import {
  ArrowLeft,
  ArrowRight,
  Cross,
  RegularArrowDownIcon,
  SearchIcon,
} from "../../modules/default-svg";
import styles from "./dashboard.module.scss";
// import DashboardSummary from "./DashboardSummary";
import ProjectManagerDashboard from "./ProjectManagerDashboard";
import ProgramManagerDashboard from "./ProgramManagerDashboard";
import PortfolioManagerDashboard from "./PortfolioManagerDashboard";
import SimpleUserDashboard from "./SimpleUserDashboard";
import Dashboard from "./Dashboard";
import { ResourceMoniteringContext } from "../resourcePlanner/resourceMonitoring/ResourceContext";
import { connect } from "react-redux";
import { getProjects } from "../../store/actions/projects.actions";
import { projects } from "../../store/selectors/projects.selector";
import { jwtDecode } from "jwt-decode";
import HeaderFilter from "./components/HeaderFilter";
import DropDown from "../../components/controls/dropdown/DropdownFluent";
// import { all } from "axios";

import { apiCall } from "../../store/services/service";
import { BASE_URL } from "../../store/services/URL";

const DashboardHeader = ({
  allProjects,
  getProjectsRequest,
  projectID,
  overviewType = null,
  isHeaderCollapsed = false
}) => {
  const {
    project,
    setProject,
    setProjects,
    setBaselines,
    setFilterBaseLine,
    setTodayTrigger,
    selectedTab,
    setSelectedTab,
    setTabView,
  } = useContext(ResourceMoniteringContext);
  const [selectedValue, setSelectedValue] = useState(
    overviewType ? "timeline" : selectedTab
  );
  const [openPopover, setIsOpenPopover] = useState("");
  const [isFilterOpenPopover, setIsFilterOpenPopover] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [ProjectId, setProjectId] = useState("");
  const [ProjectName, setProjectName] = useState("Select Project");
  const [ProgramId, setProgramId] = useState("");
  const [ProgramName, setProgramName] = useState("Select Program");
  const [PortfolioId, setPortfolioId] = useState("");
  const [PortfolioName, setPortfolioName] = useState("Select Portfolio");
  const [filterSearchTerm, setFilterSearchTerm] = useState("");
  const accessToken = JSON.parse(localStorage.getItem("accessToken"));

  const accessTokenDecoded = jwtDecode(accessToken);
  const croles = JSON.parse(accessTokenDecoded?.c_roles);
  const allowedRoleTypes = [2, 3, 4];
  // Custom sort order: Project Manager (4), Program Manager (3), Portfolio Manager (2)
  const roleOrder = { 4: 0, 3: 1, 2: 2 };
  const filteredRoles = croles
    .filter((role) => allowedRoleTypes.includes(role.Type))
    .sort((a, b) => roleOrder[a.Type] - roleOrder[b.Type]);

  const [allFilterProjects, setAllFilterProjects] = useState([]);
  const [allPrograms, setAllPrograms] = useState([]);
  const [allPortfolios, setAllPortfolios] = useState([]);

  // TODO: change this after merging localStorage_utils_implementation branch
  const isDefaultRole= JSON.parse(localStorage.getItem("roles")).some(role => role.isDefault);

  const getInitialRole = () => {
    try {
      const savedRole = localStorage.getItem("selectedRole");
      if (savedRole) {
        const parsedRole = JSON.parse(savedRole);
        const roleExists = filteredRoles.find(
          (role) => role.Type === parsedRole.Type
        );
        if (roleExists) {
          return parsedRole;
        }
      }
    } catch (error) {
      console.error("Error parsing saved role:", error);
    }
    return filteredRoles[0] || null;
  };

  const [selectedRole, setSelectedRole] = useState(getInitialRole());
  // const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    if (allProjects.length && overviewType === null) {
      setProject({ name: allProjects[0].name, id: allProjects[0].id });
      setProjects(() => allProjects);
    }
    if (allProjects.length && overviewType === "Project") {
      const project = allProjects.find((item) => item.id === projectID);
      setProject({ name: project?.name || '', id: project?.id ||  projectID});
      setSelectedTab("timeline");
      setProjects(() => allProjects);
    }
  }, [overviewType, allProjects]);

  useEffect(() => {
    if(ProjectId && ProjectName){
      setProject({ name: ProjectName, id: ProjectId });
    }
  }, [ProjectId, ProjectName]);

  useEffect(() => {
    if(project.id && ProjectId && project.id != ProjectId && project.name != ProjectName)
    {
      setProjectId(project.id);
      setProjectName(project.name);
    }
      
  }, [project]);
  
  useEffect(() => {
    if (!allProjects.length && isDefaultRole) {
      getProjectsRequest({ page: 1, size: 10 });
    }
  }, []);

  const handleChange = (value) => {
    setFilterValue(value);
    setFilterSearchTerm(value);
  };

  useEffect(() => {
    if (filterSearchTerm || isFilterOpenPopover) {
      fetchFilterData(isFilterOpenPopover);
    }
  }, [filterSearchTerm, isFilterOpenPopover]);

  const onTabSelect = (event, data) => {
    setSelectedValue(data.value);
    setSelectedTab(data.value);
    setBaselines([]);
    setFilterBaseLine(null);
    setTabView("month");
  };

  const handleFilterPopoverToggle = (type) => {
    setIsFilterOpenPopover(`${type}`);
  };

  const fetchFilterData = (entityType) => {
    if(!entityType)
      return;
    
    const url = `${BASE_URL}search/${entityType}${
      filterSearchTerm ? `?searchTerm=${filterSearchTerm}` : ""
    }`;

    return apiCall
      .get({
        url,
        isAuthToken: true,
      })
      .then((res) => {
        switch (entityType) {
          case "projects":
            setAllFilterProjects(res);
            break;
          case "programs":
            setAllPrograms(res);
            break;
          case "portfolios":
            setAllPortfolios(res);
            break;
          default:
            break;
        }
        return res;
      })
      .catch((error) => {
        console.error(`Error fetching ${entityType} data:`, error);
      });
  };

  // const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleRoleSelect = (role) => {
    const selectedRole = croles.find((r) => r.Type === role);
    setSelectedRole(selectedRole);
    try {
      localStorage.setItem("selectedRole", JSON.stringify(selectedRole));
    } catch (error) {
      console.error("Error saving role to localStorage:", error);
    }
    // setDropdownOpen(false);
  };

  const getRoleName = (roleType) => {
    // const roleNames = {
    //   0: "Custom",
    //   1: "Administrator",
    //   2: "Portfolio Manager",
    //   3: "Program Manager",
    //   4: "Project Manager"
    // };
    const roleNames = {
      2: "Portfolio Manager",
      3: "Program Manager",
      4: "Project Manager",
    };
    return roleNames[roleType] || `Role ${roleType}`;
  };

  const roleOptions =
    filteredRoles && filteredRoles.length > 0
      ? filteredRoles.map((role) => ({
          value: role.Type,
          name: getRoleName(role.Type),
        }))
      : [];

  const renderView = (type) => {
    if (type === "summary") {
      return (
        <div
          role="tabpanel"
          aria-labelledby="Summary"
          style={{ height: "calc(100% - 54px)" }}
        >
          {selectedRole?.Type === 3 ? (
            <ProgramManagerDashboard
              ProgramId={ProgramId}
              setProgramId={setProgramId}
              setProgramName={setProgramName}
            />
          ) : selectedRole?.Type === 4 ? (
            <ProjectManagerDashboard
              ProjectId={ProjectId}
              setProjectId={setProjectId}
              setProjectName={setProjectName}
            />
          ) : selectedRole?.Type === 2 ? (
            <PortfolioManagerDashboard
              PortfolioId={PortfolioId}
              setPortfolioId={setPortfolioId}
              setPortfolioName={setPortfolioName}
            />
          ) : <SimpleUserDashboard /> 
          }
        </div>
      );
    } else {
      return (
        <div
          role="tabpanel"
          aria-labelledby="Timeline"
          style={{
            height: overviewType === "Project" ? "100%" : "calc(100% - 49px)",
          }}
        >
          <Dashboard
            openPopover={openPopover}
            setIsOpenPopover={setIsOpenPopover}
            overviewType={overviewType}
            isHeaderCollapsed={isHeaderCollapsed}
          />
        </div>
      );
    }
  };

  return overviewType === "Project" ? (
    renderView(selectedValue)
  ) : (
    <div>
      {isDefaultRole && (
      <div className={styles.DbHeader}>
        <div className="d-flex  w-full align-items-center">
            <TabList
              selectedValue={selectedValue}
              onTabSelect={onTabSelect}
              className="DashboardTabs"
            >
              <Tab id="Summary" value="summary" className="summary-tab">
                <div className="flex items-center">
                  <span className="tab-label">Summary</span>
                  {filteredRoles.length > 1 && selectedValue !== "timeline" && (
                    <span className="role-filter-dashboard">
                      <DropDown
                        placeholder="Dashboard"
                        options={roleOptions}
                        defaultVal={" - " + getRoleName(selectedRole?.Type)}
                        onChange={(val) => {
                          handleRoleSelect(val);
                        }}
                        dropDownwd={"role-dropdown"}
                      />
                    </span>
                  )}
                </div>
              </Tab>
              <Tab id="Timeline" value="timeline" className="timeline-tab">
                <span className="tab-label">Timeline</span>
              </Tab>
            </TabList>
          {selectedRole?.Type === 4 && selectedValue !== "timeline" && (
            <HeaderFilter
              itemType="projects"
              selectedItemId={ProjectId}
              selectedItemName={ProjectName}
              allItems={allFilterProjects}
              filterValue={filterValue}
              handleChange={handleChange}
              openPopover={isFilterOpenPopover}
              setIsOpenPopover={setIsFilterOpenPopover}
              setSelectedItemId={setProjectId}
              setSelectedItemName={setProjectName}
              setBaselines={setBaselines}
              setFilterBaseLine={setFilterBaseLine}
              styles={styles}
              handleFilterPopoverToggle={handleFilterPopoverToggle}
              setFilterSearchTerm={setFilterSearchTerm}
            />
          )}

          {selectedRole?.Type === 3 && selectedValue !== "timeline" && (
            <HeaderFilter
              itemType="programs"
              selectedItemId={ProgramId}
              selectedItemName={ProgramName}
              allItems={allPrograms}
              filterValue={filterValue}
              handleChange={handleChange}
              openPopover={isFilterOpenPopover}
              setIsOpenPopover={setIsFilterOpenPopover}
              setSelectedItemId={setProgramId}
              setSelectedItemName={setProgramName}
              setBaselines={setBaselines}
              setFilterBaseLine={setFilterBaseLine}
              styles={styles}
              handleFilterPopoverToggle={handleFilterPopoverToggle}
              setFilterSearchTerm={setFilterSearchTerm}
            />
          )}

          {selectedRole?.Type === 2 && selectedValue !== "timeline" && (
            <HeaderFilter
              itemType="portfolios"
              selectedItemId={PortfolioId}
              selectedItemName={PortfolioName}
              allItems={allPortfolios}
              filterValue={filterValue}
              handleChange={handleChange}
              openPopover={isFilterOpenPopover}
              setIsOpenPopover={setIsFilterOpenPopover}
              setSelectedItemId={setPortfolioId}
              setSelectedItemName={setPortfolioName}
              setBaselines={setBaselines}
              setFilterBaseLine={setFilterBaseLine}
              styles={styles}
              handleFilterPopoverToggle={handleFilterPopoverToggle}
              setFilterSearchTerm={setFilterSearchTerm}
            />
          )}
        </div>
        <div className="d-flex align-items-center gap-2 justify-content-end">
          {selectedValue !== "summary" && (
            <CustomPopover
              width={"364px"}
              icon={
                <CustomButton
                  btnClass={`${styles.dashboardSelect} btn_combo btn_combo_white`}
                  label={
                    project?.name?.length > 12
                      ? `${project.name.substring(0, 12)}..`
                      : project.name
                  }
                  rightIcon={
                    <span className="ms-1 d-inline-flex">
                      <RegularArrowDownIcon />
                    </span>
                  }
                  clickHandler={() => {setIsOpenPopover("projects"); setIsFilterOpenPopover("projects")}}
                />
              }
              status={openPopover === "projects"}
            >
              <div className="d-flex flex-column gap-3">
                <div className="d-flex justify-content-between align-items-center  ">
                  <h6 className=" ">Filter by projectss</h6>
                  <div onClick={() => setIsOpenPopover(null)}>
                    <Cross />
                  </div>
                </div>
                <div>
                  <IconInput
                    icon={<SearchIcon />}
                    placeholder={"Search"}
                    handleChange={handleChange}
                  />
                </div>
                <div style={{ height: "176px", overflow: "auto" }}>
                  <div className="d-flex flex-wrap gap-2">
                    {[...allProjects]
                      ?.filter(
                        (item) =>
                          item.name !== project.name &&
                          item?.name
                            ?.toLowerCase()
                            ?.includes(filterValue?.toLowerCase())
                      )
                      .map((project) => (
                        <span
                          className={styles.projectItem}
                          value={project.id}
                          onClick={() => {
                            setBaselines([]);
                            setFilterBaseLine(null);
                            setTimeout(() => {
                              setProject(project);
                              setIsOpenPopover(null);
                            }, 1000);
                          }}
                        >
                          {project.name}
                        </span>
                      ))}
                  </div>
                </div>
              </div>
            </CustomPopover>
          )}
          {selectedValue !== "summary" && (
            <>
              <CustomButton
                btnClass="todayBtn"
                label="Today"
                name="today"
                id="cars"
                clickHandler={() => {
                  setTodayTrigger(false);
                  setTimeout(() => {
                    setTodayTrigger(true);
                  }, 0);
                }}
              />
            </>
          )}
        </div>
      </div>
      )}
      <>{renderView(selectedValue)}</>
    </div>
  );
};

const mapDispatchToProps = {
  getProjectsRequest: getProjects,
};

const mapStateToProps = (state) => {
  const allProjects = projects(state);
  return { allProjects };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardHeader);
